(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9422],{

/***/ 9422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CookieBanner": function() { return /* reexport */ CookieBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/CookieBanner/cookieBanner.module.sass
var cookieBanner_module = __webpack_require__(53830);
var cookieBanner_module_default = /*#__PURE__*/__webpack_require__.n(cookieBanner_module);
// EXTERNAL MODULE: ./utils/isBlackFridayCheck.js
var isBlackFridayCheck = __webpack_require__(66373);
;// CONCATENATED MODULE: ./components/CookieBanner/CookieBanner.jsx







var CookieBanner = function(param) {
    var onOpen = param.onOpen, timeToCookie = param.timeToCookie, isTablet = param.isTablet, isMobile = param.isMobile;
    var closeBanner = function() {
        onOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,classcat/* default */.Z)([
                [
                    (cookieBanner_module_default()).wrapperMobile
                ],
                (0,_define_property/* default */.Z)({}, (cookieBanner_module_default()).wrapperTablet, isTablet), 
            ]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (cookieBanner_module_default()).textBlock,
                    href: (0,isBlackFridayCheck/* isNewYear */.m)() ? "/novogodniy-keshbek-za-pokupku-kruizov" : "/2026",
                    children: (0,isBlackFridayCheck/* isNewYear */.m)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (cookieBanner_module_default()).text,
                        children: "Выигрывайте новогодний кешбэк до 20%"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (cookieBanner_module_default()).text,
                        children: "Круизы на 2026 год со скидками раннего бронирования до 20%!"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (cookieBanner_module_default()).closeButtonMobile,
                    onClick: function() {
                        return [
                            (0,dist.setCookie)(null, "closeBanner", "true"),
                            closeBanner(),
                            (0,dist.setCookie)(null, "timeToOpenBanner", timeToCookie), 
                        ];
                    },
                    children: " "
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,classcat/* default */.Z)([
                [
                    (cookieBanner_module_default()).wrapper
                ],
                (0,_define_property/* default */.Z)({}, (cookieBanner_module_default()).wrapperTablet, isTablet), 
            ]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (cookieBanner_module_default()).textBlock,
                    children: [
                        (0,isBlackFridayCheck/* isNewYear */.m)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (cookieBanner_module_default()).text,
                            children: "Выигрывайте новогодний кешбэк до 20%"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (cookieBanner_module_default()).text,
                            children: "Круизы на 2026 год со скидками раннего бронирования до 20%!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,isBlackFridayCheck/* isNewYear */.m)() ? "/novogodniy-keshbek-za-pokupku-kruizov" : "/2026",
                            className: (cookieBanner_module_default()).insideButton,
                            children: (0,isBlackFridayCheck/* isNewYear */.m)() ? "Перейти" : "Хочу"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (cookieBanner_module_default()).closeButton,
                    onClick: function() {
                        return [
                            (0,dist.setCookie)(null, "closeBanner", "true"),
                            closeBanner(),
                            (0,dist.setCookie)(null, "timeToOpenBanner", timeToCookie), 
                        ];
                    },
                    children: " "
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/CookieBanner/index.js



/***/ }),

/***/ 53830:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"cookieBanner_closeButton__8ASxf","closeButtonMobile":"cookieBanner_closeButtonMobile__nU_FX","insideButton":"cookieBanner_insideButton__c2xeK","subText":"cookieBanner_subText__TOSau","textBlock":"cookieBanner_textBlock__vjbIQ","text":"cookieBanner_text__W94_Y","textBf":"cookieBanner_textBf__x7M6T","wrapper":"cookieBanner_wrapper__OZxdo","wrapperMobile":"cookieBanner_wrapperMobile__SrmYG","wrapperBf":"cookieBanner_wrapperBf__nhCI9"};

/***/ })

}]);